module.exports = __webpack_public_path__ + "img/25.a8329fbf.jpg";